export default "__VITE_ASSET__B$UVBpky__"